exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-document p[data-v-58c509d4] {\n  margin-bottom: 1em;\n}\n.no-document p[data-v-58c509d4]:last-child {\n  margin-top: 1em;\n  margin-bottom: 0;\n  font-style: italic;\n}\nul li[data-v-58c509d4] {\n  padding-top: .6em;\n  list-style: square;\n  margin-left: 2em;\n}\nimg[data-v-58c509d4] {\n  border: 8px solid #f6f6f6;\n}\n", ""]);

// exports
